<template>
        <form @submit.prevent="submit" :class="errorClass">
          <rp-textinput
            v-model="resource.email"
            placeholder="email"
            :error="emailError"
            @input="touch('email')"/>
      
          <rp-select
            class="gender"
            v-model="resource.gender"
            placeholder="Gender"
            @input="touch('gender')"
            :error="genderError">
            <option v-for="gender in genders" :key="gender.value" :value="gender.value">{{gender.label}}</option>
          </rp-select>
      
          <rp-textinput
            v-model="resource.first_name"
            placeholder="First Name"
            :error="first_nameError"
            @input="touch('first_name')"/>
      
          <rp-textinput
            v-model="resource.last_name"
            placeholder="Last Name"
            :error="last_nameError"
            @input="touch('last_name')"/>
      
          <rp-select
            v-model="resource.status"
            placeholder="Status"
            @input="touch('status')"
            :error="statusError">
            <option v-for="status in statuses" :key="status.value" :value="status.value">{{status.label}}</option>
          </rp-select>
      
          <rp-button :disabled="isInvalid" type="primary">Submit</rp-button>
        </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required, sameAs} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'
  

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import Password from '../../../components/ui/inputs/PasswordInput'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import DatePicker from '../../../components/ui/inputs/DatePicker'
  import Select from '../../../components/ui/inputs/StyledSelect'
  import Checkbox from '../../../components/ui/inputs/Checkbox'

  export default {
    name: 'AdminForm',
    mixins: [validationMixin, form],
    props: {
      statuses: Array,
      genders: Array
    },

    components: {
      'rp-button': Button,
      'rp-password': Password,
      'rp-textinput': TextInput,
      'rp-datepicker': DatePicker,
      'rp-select': Select,
      'rp-checkbox': Checkbox
    },

    computed: {
      ...errorMessages([
        'email',
        'gender',
        'status',
        'first_name',
        'last_name',
        'accept_terms'])
    },

    validations: {
      resource: {
        email: {required, email},
        gender: {required},
        status: {required},
        first_name: {required},
        last_name: {required}
      }
    }
  }
</script>
      


// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/Admin.vue